import { WorkItemBold } from './workitem-bold';
import { EmailItem } from '../interfaces/email-item.interface';
import { WorkItemTypes } from '../constants/workitem-types';

export class WorkItemEmail extends WorkItemBold implements EmailItem {
  public readonly type: string = WorkItemTypes.EMAIL;

  Name: string;
  Text: string;
  NewItem: boolean;
  UserEmailName: string;
  UserDisplayName: string;

  FirstLine: string;
  IsAnswered: boolean = false;

  constructor(workItem) {
    super(workItem);
  }
}
